import React from 'react';
import { BadgeMedal, TIER_LABEL_COLORS, getTierOverlayThemeStyle } from './VideoBadgeProgress';
import './BadgeOverlayScreen.css';

/**
 * Badge tier-up celebration card — pro-success theme, flies to home badge slot.
 */
export default function BadgeOverlayScreen({ tierKey = 'bronze', tierName = 'Bronze', fast = false }) {
  const tierColor = TIER_LABEL_COLORS[tierKey] || TIER_LABEL_COLORS.bronze;
  const themeStyle = getTierOverlayThemeStyle(tierKey);

  return (
    <div
      className={`badge-overlay-screen badge-overlay-screen--${tierKey}${fast ? ' badge-overlay-screen--fast' : ''}`}
      style={themeStyle}
    >
      <div className="badge-overlay-screen-medal-wrap">
        <span className="badge-overlay-screen-glow" aria-hidden="true" />
        <div className="badge-overlay-screen-medal">
          <BadgeMedal tierKey={tierKey} size={148} />
        </div>
      </div>
      <h2 className="badge-overlay-screen-title">Achievement Unlocked</h2>
      <p className="badge-overlay-screen-tier" style={{ color: tierColor }}>
        {tierName}
      </p>
    </div>
  );
}
